import React from "react";
import { linkHelper } from "../../helper/LinkHelper";
import { Link } from "react-router-dom";
import ReactGa from "react-ga";
import { trackEvent } from "../../helper/GoogleAnalytics";
const BuyNow = ({ bookDetail, handleShow, handleClose }) => {
  const {
    book_slug,
    buy_now_url,
    exam_copy,
    publishdate_default,
    publishdate_hb,
    publishdate_pb,
    pageCount: page_count,
    width,
    height,
    winch,
    hinch,
    companion_url,
    oa_download_link,
    sample_book_url,
    pdf_preview,
  } = bookDetail?.book_detail;
  //const download_id =`download_${book_slug}`;
  //const buynow_id =`buynow_${book_slug}`;

  const download_id =`download_oa_book`;
  const buynow_id =`buynow_book_click`;

  
  // const [isPopupVisible, setPopupVisible] = useState(false);
  const handleShowHandler = () => {
    handleShow();
  };
  const handleCloseHandler = () => {
    handleClose();
  };

  return (
    <>
      <div className="container-fluid buy_now_container">
        <div className="row">
          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 buy_now_order">
            <div
              className="container main_container_bg"
              style={{ border: "solid red 0px" }}
            >
              <div className="row" style={{ border: "solid green 0px" }}>
                <div
                  className="col-xs-12 col-sm-3 col-md-4 col-lg-3 button_column"
                  style={{ borderRight: "solid green 0px" }}
                >
                  <div className="buy_now_overall pull-left">
                    {/* <ReactGa.OutboundLink
                      eventLabel="Buy_Now"
                      id={book_slug}
                      className="buy_now_button pull-left"
                      to={
                        buy_now_url ??
                        `http://www.wiley.com/WileyCDA/WileyTitle/productCd-`
                      }
                      rel="noreferrer"
                      style={{ cursor: "pointer" }}
                    >
                      Buy Now
                    </ReactGa.OutboundLink> */}
                    <a 
                     id={buynow_id}
                     className="buy_now_button pull-left"
                     rel="noreferrer" 
                     href={
                        buy_now_url ??
                        `http://www.wiley.com/WileyCDA/WileyTitle/productCd-`
                      }
                     style={{ cursor: "pointer" }}>
                     Buy Now
                     </a>
                    <p className="pull-left button_tag_name">From Wiley.com</p>
                  </div>
                  {exam_copy !== "#" && exam_copy !== "" && exam_copy && (
                    <div className="buy_now_overall1 pull-left">
                      <a
                        className="order_exam_button pull-left"
                        href={exam_copy}
                        rel="noreferrer"
                        style={{ cursor: "pointer" }}
                      >
                        Order Exam Copy
                      </a>
                      <p className="pull-left order_exam_btn_tag">
                        For Lecturers Only
                      </p>
                    </div>
                  )}
                  {pdf_preview !== "" && pdf_preview && (
                    <div className="buy_now_overall1 pull-left">
                      <a
                        className="order_exam_button pull-left" 
                        rel="noreferrer"
                        style={{ cursor: "pointer" }}
                        onClick={handleShowHandler}
                      >
                        Show Preview
                      </a>
                     
                    </div>
                  )}
                </div>
                <div className="col-sm-12 col-md-12 col-lg-1_vr hidden-xs" />
                <div
                  className="col-xs-12 col-sm-4 col-md-3 col-lg-4 default_dektop_padding"
                  style={{ borderRight: "solid green 0px" }}
                >
                  <span className="more_info pull-left">More Info</span>
                  <ul className="books_desc_list pull-left">
                    {publishdate_default && <li>{publishdate_default}</li>}
                    {(publishdate_hb || publishdate_pb) && <li>{publishdate_hb ? publishdate_hb : publishdate_pb}</li>}
                    {page_count && <li>{page_count} pages</li>}
                    <li>
                      {width || 0} x {height || 0} mm / {winch || 0} x{" "}
                      {hinch || 0} in
                    </li>
                  </ul>
                  {bookDetail?.book_detail?.series_list &&
                    bookDetail?.book_detail?.series_list?.series_name && (
                      <div style={{ clear: "both", paddingTop: "3px" }}>
                        <Link
                          to={`/serieslanding?subject_slug=${bookDetail?.book_detail?.series_list?.subject_slug}&series_slug=${bookDetail?.book_detail?.series_list?.series_slug}`}
                        >
                          {`${bookDetail?.book_detail?.series_list?.series_name} Series`}
                        </Link>
                      </div>
                    )}
                  {companion_url !== "" && companion_url && (
                    <span className="pull-left visit_books">
                      {linkHelper({
                        url: companion_url,
                        title: "Visit book companion site",
                        target: "_blank",
                      })}
                    </span>
                  )}
                  {oa_download_link !== "" && oa_download_link && (
                    <div style={{ marginTop: "10px", float: "left" }}>
                      <span className="pull-left">
                        This is an <Link to="/oa/">Open Access</Link> book
                      </span>
                      <span className="pull-left">
                        <a
                          href={oa_download_link}
                          target="_blank"
                          className="oa_download_link"
                          id={download_id}
                          download
                          rel="noreferrer"
                          // onClick={trackEvent('Downloaded OA PDF', bookDetail?.book_detail?.title, oa_download_link)}
                        >
                          Click to download title
                        </a>
                      </span>
                    </div>
                  )}
                  {sample_book_url && sample_book_url !== "" && (
                    <span className="pull-left visit_books">
                      <a
                        href={sample_book_url}
                        target="_blank"
                        download
                        rel="noreferrer"
                      >
                        Click here to view a sample of the book
                      </a>
                    </span>
                  )}
                </div>
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-1_vr hidden-xs" />
                <div
                  className="col-xs-12 col-sm-4 col-md-4 col-lg-4 default_dektop_padding avaliable_formats_mobile"
                  style={{ border: "solid green 0px" }}
                >
                  <span className="more_info pull-left">Available Formats</span>
                  <ul className="books_rate_desc pull-left">
                    {bookDetail?.available_formats &&
                    typeof bookDetail?.available_formats === "object" &&
                    Object.entries(bookDetail?.available_formats).length ? (
                      Object.entries(bookDetail?.available_formats).map(
                        (f, i) => (
                          <React.Fragment key={i}>
                            <li className="hardcover_euro">
                              {Object.values(f)?.[1]?.format}
                              {Object.values(f)?.[1]
                                ?.price?.split(",")
                                .map((price, i) => (
                                  <span className="rate_space" key={i}>
                                    {price}
                                  </span>
                                ))}
                            </li>
                            <li>{Object.values(f)?.[1]?.isbn}</li>
                          </React.Fragment>
                        )
                      )
                    ) : (
                      <li className="hardcover_euro">
                        This product is not available for sale in this region
                      </li>
                    )}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BuyNow;
